module.exports = __webpack_public_path__ + "img/darkmode-video-preview-step2.9fd86d48.svg";